import { Divider, Drawer } from "@mantine/core";
import { useDrawerStore } from "../../../store/dashboard.store";
import "./main-drawer.css";

const MainDrawer = () => {
  const { open, title, popPage, pages } = useDrawerStore((state) => state);
  return (
    <Drawer
      opened={open}
      onClose={() => popPage()}
      title={title}
      padding="xl"
      size="xl"
      closeOnClickOutside={false}
      position="right"
      radius="xl"
      overlayProps={{ backgroundOpacity: 0.45, blur: 3 }}
    >
      <Divider mb="md" />
      {pages[pages.length - 1]}
    </Drawer>
  );
};

export default MainDrawer;
